import React from 'react';
import { LogoImage } from '../../styles';
import { useClient } from '@context/presentation';
import { generateStorageBlobUrl } from '@utils/generateAssetLinks';
import { BLOB_TYPES, VIEWPORTS } from '@constants';

export const Logo = ({ view = 'slide', viewport = VIEWPORTS.desktop }) => {
    const { firmShortName } = useClient();
    const { logo, icon } = BLOB_TYPES;
    const { mobile, desktop } = VIEWPORTS;
    const logoType = viewport === mobile ? icon : logo;
    const logoUrl = generateStorageBlobUrl(logoType, firmShortName);
    const isDesktop = viewport === desktop;

    return (
        <LogoImage
            desktop={isDesktop}
            viewport={viewport}
            view={view}
            src={logoUrl}
            alt={`${firmShortName} logo`} />
    );
};

export default Logo;
